import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import React, { useMemo } from "react";
import { CMSearchResultCellFrame } from "../CMSearchResultCellFrame/CMSearchResultCellFrame";
import {
  ComponentMultiStyleConfig,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";

export type CMSearchResultCellTextProps = {
  value?: string;
} & ComponentStyleProps;

export const CMSearchResultCellText = ({
  value,

  sx,
  ...rest
}: CMSearchResultCellTextProps) => {
  const styles = useMultiStyleConfig("CMSearchResultCellTextStyles");

  const containerStyles = useMemo(
    () => ({ ...styles.container, ...sx }),
    [styles.container, sx],
  );

  return (
    <CMSearchResultCellFrame sx={containerStyles} {...rest}>
      <Text sx={styles.content}>{value}</Text>
    </CMSearchResultCellFrame>
  );
};

export const CMSearchResultCellTextStyles: ComponentMultiStyleConfig = {
  parts: ["container", "content"],
  baseStyle: {
    container: {},
    content: {
      whiteSpace: "pre-wrap",
      overflowWrap: "anywhere",
    },
  },
};
